import React from 'react';
import { Div } from '../../Atoms/Div';
import { FontIcon, Size } from '../../Atoms/FontIcon';
import { SpacingProps, ElementProps } from '../../../types/MaterialUI';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { useTheme } from '@mui/material';

export interface Props extends SpacingProps, ElementProps {
  size?: Size;
  icon: IconDefinition;
}

const BubbleIconComponent = React.forwardRef<any, Props>(
  (props: Props, ref: any) => {
    const { size, icon, ...passThroughProps } = props;
    const theme = useTheme();
    return (
      <Div
        {...passThroughProps}
        dataTest="bubbleicon-molecule"
        borderRadius="50%"
        width="fit-content"
        height="fit-content"
        backgroundColor={theme.palette.secondary.dim}
      >
        <FontIcon
          ref={ref}
          icon={icon}
          color={theme.palette.secondary.main}
          size={size}
        />
      </Div>
    );
  }
);

BubbleIconComponent.displayName = 'BubbleIcon';
BubbleIconComponent.defaultProps = {
  size: 'lg',
  p: 1,
};

export const BubbleIcon = BubbleIconComponent;
